import { useMemo } from 'react';
import { EnterpriseLocation } from 'models/Enterprises';
import { getSortComparator } from 'utils';

export default function useMemberLocations(
  memberLocations: EnterpriseLocation[] = [],
) {
  const sortedMemberLocations = useMemo(
    () =>
      memberLocations.sort((a, b) =>
        getSortComparator(a.name.toLowerCase(), b.name.toLowerCase()),
      ),
    [memberLocations],
  );

  const memberLocationsOptions = useMemo(
    () =>
      sortedMemberLocations.map(({ _id, name }) => ({
        value: _id,
        label: name,
      })),
    [sortedMemberLocations],
  );

  return { sortedMemberLocations, memberLocationsOptions };
}
